import axios from '../services/api.service';

// Mode picks the RAG path: 'book' searches the IpOp book, 'advice' crosses the
// current-screen context with the book using deeper reasoning. Omit for the
// default auto-routing used by the full Assistant screen.
export type ChatMode = 'book' | 'advice';

interface AskOptions {
  mode?: ChatMode;
  context?: string; // current-screen context, only sent in 'advice' mode
}

// Ask the RAG assistant a question. Pass conversationId to continue an existing
// thread, or omit it to start a new one. Returns the answer, sources and the
// updated credit balance (or the error so callers can detect a 402 — no credits).
export const assistantAsk = async (
  question: string,
  conversationId?: string | null,
  options?: AskOptions
) => {
  try {
    const { data } = await axios.post('/chat/ask', {
      question,
      conversation_id: conversationId || null,
      mode: options?.mode,
      context: options?.mode === 'advice' ? options?.context : undefined
    });
    return { data, err: null };
  } catch (error) {
    return { data: null, err: error };
  }
};

export const assistantListConversations = async () => {
  try {
    const { data } = await axios.get('/chat/conversations');
    return { conversations: data?.conversations || [], err: null };
  } catch (error) {
    return { conversations: [], err: error };
  }
};

export const assistantGetConversation = async (id: string) => {
  try {
    const { data } = await axios.get(`/chat/conversations/${id}`);
    return {
      conversation: data?.conversation || null,
      messages: data?.messages || [],
      err: null
    };
  } catch (error) {
    return { conversation: null, messages: [], err: error };
  }
};

export const assistantGetCredits = async () => {
  try {
    const { data } = await axios.get('/chat/credits');
    return data?.credits ?? null;
  } catch (error) {
    console.error(error);
    return null;
  }
};
